import React from 'react'

import { CaretIcon } from '@ui/icons/Caret.icon'

import { Box } from '@shared/components/Box'

interface TPSLMobileButtonProps {
  onPress: () => void
}

export const TPSLButton: React.FC<TPSLMobileButtonProps> = ({ onPress }) => {
  return (
    <Box
      flex
      direction='column'
      px='x16'
      py='x16'
      radius='x16'
      border='outline-low-em'
      role='button'
      tabIndex={0}
      onClick={onPress}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onPress()
        }
      }}
    >
      <Box flex justify='space-between' gap='x12' align='center'>
        <Value>TP/SL</Value>
        <CaretIcon.Right size={20} />
      </Box>
    </Box>
  )
}

const Value: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span style={{ color: 'var(--text-high-em)', fontWeight: 500 }}>{children}</span>
)
